<div class="modal fade callLogModal" tabindex="-1" data-backdrop="false" role="dialog" aria-labelledby="myLargeModalLabel"
     id="modalPopUp">
  <div id="call-log-modal-dialogue" class="modal-dialog">
    <div class="modal-content" *ngIf="showCallLogModal">
      <div class="modal-header">
        <h4 class="modal-title" translate>
          Log.call
          <span class="pointer-cursor float-right" (click)="closeModal()">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </span>
        </h4>
      </div>
      <div class="modal-body">
        <ng-container>
          <form *ngIf="callForm" [formGroup]="callForm">
            <div class="job-complete" *ngIf="callActivityShow">
              <label class="checkbox-button margin-btm0" for="callComplete">
                  <input class="checkbox-button__input" type="checkbox" id="callComplete"
                      [checked]="completed" (change)="completeActivity($event)" />
                  <span class="checkbox-button__control complete-check"></span>
                  <span class="checkbox-button__label" translate><i class="fa fa-phone margin-r5"
                          aria-hidden="true"></i>
                      <span translate>activity.call.today</span></span>
              </label>
            </div>
            <select class="full-width-select2 select-blk" placeholder="To"
                    formControlName="contactTelephoneId">
              <option hidden value="" disabled selected>To</option>
              <option  *ngIf="isContactNotFound" class="no-contact-found" disabled > <span>No matched found</span> </option>
              <ng-container *ngFor="let contact of customerCallDetails">
                <optgroup label="{{contact?.contactName}}">
                  <option *ngFor="let details of contact?.contacts" value="{{details?.id}}">
                    {{details?.contactNumber}}</option>
                </optgroup>
              </ng-container>
            </select>
              <select class="full-width-select2 select-blk call-type-dropdown" formControlName="callType">
              <option hidden value="" disabled selected>Inbound/outbound call</option>
              <option *ngFor="let type of callType" [value]="type?.id">
                {{type?.value}}</option>
            </select>

              <quill-editor-custom [tagsList]="usersList" [form]="callForm" [screen]="'opportunity_notes'"
                                   (contentChanged)="onContentChange($event)"
                                   [lableName]="'note'"></quill-editor-custom>
          </form>
            <div class="selected-user-container"
                 *ngIf="selectedUsersList && selectedUsersList.length > 2 && (screenType == 'jobs' || screenType == 'jobs_tab')">
                <input type="checkbox" [(ngModel)]="isAssigned" [checked]="isAssigned" value="isAssigned"/>
                <span>Assign the job to</span>
                <span class="selected-user-list">
                     <app-user-icon-list [usersList]="selectedUsersList.length"
                                         [imageList]="selectedUsersList"></app-user-icon-list>
                </span>
            </div>

            <div class="selected-user-container align-item-center"
                 *ngIf="selectedUsersList && selectedUsersList.length >=1 && selectedUsersList.length <= 2 && (screenType == 'jobs' || screenType == 'jobs_tab') && (usersWritePermission || usersUpdatePermission)">
                <input type="checkbox" [(ngModel)]="isAssigned" [checked]="isAssigned" value="isAssigned"/>
                <span>Assign the job to</span>
                <ng-container *ngFor="let user of selectedUsersList">
                    <img src="{{user?.profilepicture}}" class="user-circle-img" alt="user-icon"/>
                    <span class="user-name">{{ user?.username }}</span>
                </ng-container>
            </div>
        </ng-container>
      </div>
      <!-- Footer -->
      <div class="modal-footer" [ngClass]="{'attachments-over':modalBack == true}">
        <div class="row-fluid">
          <div class="float-right" style="display: flex">
            <span class="activity-left">
              <div class="schedule-check" *access = "['ScheduleActivity.writeaccess']">
                <label class="checkbox-button checkbox-text-center" for="completeScheduleActivity">
                  <input class="checkbox-button__input" type="checkbox" id="completeScheduleActivity"
                         [checked]="scheduled" (change)="isScheduledActivity($event)" />
                  <span class="checkbox-button__control"></span>
                  <span class="checkbox-button__label" translate="">Schedule.new.activity</span>
                </label>
              </div>
            </span>
            <button class="btn disgard-button" (click)="closeModal()" translate>
              Discard
            </button>
            <button *ngIf="callForm" class="btn btn-primary" [disabled]="!callForm.valid || saveDisabled"
                    (click)="saveCall()" translate>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
